module.exports = __webpack_public_path__ + "static/media/chevron-left.d0ede820.svg";